import createClient from 'openapi-fetch';
import { localizedFetch } from '@/lib/apiClient';
import { getPersianErrorMessage } from '@/lib/persianUi';

const client = createClient({
    baseUrl: '/api/v1',
    credentials: 'include',
    fetch: localizedFetch,
});

export async function simulateReferralProgram(payload) {
    const { data, error } = await client.POST('/super_admin/referral/simulate', {
        body: payload,
    });
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در محاسبه شبیه‌ساز.'));
    }
    return data;
}

export async function compareModels(payload) {
    const { data, error } = await client.POST('/super_admin/referral/compare', {
        body: payload,
    });
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در مقایسه مدل‌ها.'));
    }
    return data;
}

export async function getSuggestedCaps(marginPercent, minMarginPercent = 3) {
    const params = new URLSearchParams();
    params.set('margin_percent', String(marginPercent));
    params.set('min_margin_percent', String(minMarginPercent));

    const { data, error } = await client.GET(
        `/super_admin/referral/suggested-caps?${params}`
    );
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در دریافت پیشنهادها.'));
    }
    return data;
}

export async function createConfig(payload) {
    const { data, error } = await client.POST('/super_admin/referral/configs', {
        body: payload,
    });
    if (error) {
        throw new Error(getPersianErrorMessage(error, 'خطا در ذخیره تنظیمات.'));
    }
    return data;
}